const Landing = () =>
    import(/* webpackChunkName: "landing" */ "./components/Landing.vue");
const Main = () =>
    import(/* webpackChunkName: "main" */ "./components/Main.vue");
const List = () =>
    import(/* webpackChunkName: "list" */ "./components/List.vue");
const Detail = () =>
    import(/* webpackChunkName: "detail" */ "./components/Detail.vue");

export default [
    {
        path: "/",
        name: "landing",
        component: Landing
    },
    {
        path: "/main",
        name: "main",
        component: Main
    },
    {
        path: "/list",
        name: "list",
        component: List
    },
    {
        path: "/project:prjIdx",
        name: "detail",
        component: Detail,
        props: true
    },
    {
        path: "*",
        redirect: "/"
    }
];
